
import "./App.css";
import { HashRouter } from "react-router-dom";
import  { AllRouter,AuthRouter} from "./router/router";
import "bootstrap/dist/css/bootstrap.min.css";

import { Provider, useSelector } from "react-redux";
import store, { persistor, RootState } from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline } from "@material-ui/core";
import { Header } from "./components/header/Header";
import { Navbar } from "./components/navbar/Navbar";

import useStyles from "./style";

import PropTypes from "prop-types";
import { PersistGate } from "redux-persist/integration/react";


const App = () => {
  // const [user, setUser] = useState(localStorage.getItem("admin_user"));
  const { adminUser } = useSelector((state: RootState) => state.admin);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          <HashRouter>
            <ToastContainer />

            {adminUser ? <MainNav /> : <AuthRoutes />}
          </HashRouter>
        </div>
      </PersistGate>
    </Provider>
  );
};
const MainNav = (props: any) => {
  const { window } = props;
  const container =
    window !== undefined ? () => window().document.body : undefined;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      
      <CssBaseline />
      <Header></Header>
      <Navbar container={container} handleDrawerToggle={() => {}} />
      <main className={classes.content}>
        <AllRouter />
      </main>
    </div>
  );
};

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const AuthRoutes = () => {
  return <AuthRouter />;
};
export default App;
